export default {
  controlBookInfo: {},
  controlBookRecords: [],
  controlBookRecordsTotal: 0,
  tokenTransactions: [],
  tokenTransactionsTotal: 0,
};
